var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employe_filters",on:{"click":_vm.goToCreate}},[_c('img',{staticClass:"employe_filters-item",attrs:{"src":require("../../assets/images/vitrinas-icons/create.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }